import React, { useEffect } from 'react'
import { StyledDivIcons, StyledMusicPlayer, StyledBorder, Tooltip, StyledDivPlayer } from './menu-actions.styled.component'
import { MdVolumeMute, MdFullscreen, MdFullscreenExit, RiShareLine } from 'react-icons/all'
import { VscMute } from 'react-icons/all'
import { IconVR } from '../../components/fontawesome'
import { setAudioMuted } from '../sound-player'

const MenuActionsComponent = ({ onClickVR, muted }) => {
  const [fullScreen, setFullScreen] = React.useState(false)
  const [showMuted, setShowMuted] = React.useState(false)
  const [ showTootip, setShowTooltip ] = React.useState(false);
  
  useEffect(() => {
    if(muted !== showMuted) setShowMuted(muted)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [muted])

  const activeFullScreen = () => {
    setFullScreen(!fullScreen)
    const el = document.documentElement;
    if(fullScreen) {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) { /* Safari */
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) { /* IE11 */
        document.msExitFullscreen();
      }
    } else {
      if (el.requestFullscreen) {
        el.requestFullscreen();
      } else if (el.webkitRequestFullscreen) { /* Safari */
        el.webkitRequestFullscreen();
      } else if (el.msRequestFullscreen) { /* IE11 */
        el.msRequestFullscreen();
      }
    }
  }

  return (
    <StyledDivPlayer>
      <StyledMusicPlayer>
        <StyledBorder />
        <StyledDivIcons>
          {
            showMuted ?
            <VscMute
              style={{ paddingLeft: '2px' }}
              onClick={() => {
                setShowMuted(!showMuted)
                setAudioMuted(false)
              }}
              fill='#fff'
              strokeWidth='1px'
              stroke="transparent"
              size='1.3em' /> :
            <MdVolumeMute
              onClick={() => {
                setShowMuted(!showMuted)
                setAudioMuted(true)
              }}
              fill='none'
              stroke='#fff'
              strokeWidth='1px'
              size='1.3em' />
          }
          {
            fullScreen ? 
            <MdFullscreenExit onClick={() => activeFullScreen()} fill='#fff' size='1.3em' /> : 
            <MdFullscreen onClick={() => activeFullScreen()} fill='#fff' size='1.3em' />
          }
          <RiShareLine
            onClick={() => {
              if(showTootip) return;
              navigator.clipboard.writeText(`${window.location.href}`)
              setShowTooltip(true);
              if(!showTootip) setTimeout(() => {
                setShowTooltip(false);
              }, 3100)
            }}
            color={'rgba(255,255,255, .7)'}
            size='1.02em' />
          <IconVR onClick={() => onClickVR()}/>
          {showTootip && <Tooltip>copied to clipboard</Tooltip>}
        </StyledDivIcons>
      </StyledMusicPlayer>
    </StyledDivPlayer>
  )
};

export default MenuActionsComponent;
